import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20artistic%20anime%20style%20illustration%20of%20a%20fantasy%20world%20with%20floating%20islands%20cherry%20blossom%20trees%20and%20a%20warm%20golden%20sunset%2C%20soft%20dreamy%20atmosphere%2C%20ethereal%20clouds%2C%20magical%20energy%20particles%2C%20Japanese%20manga%20aesthetic%2C%20clean%20composition%2C%20vibrant%20warm%20colors&width=1800&height=1200&seq=hero-bg-manga&orientation=landscape"
        alt="57漫画网 - 蜜桃少年漫画"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            蜜桃少年漫画
          </h1>
          <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
            57漫画网在线免费阅读蜜桃少年漫画全集，畅读热血、玄幻、恋爱、搞笑等精彩漫画
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/comic/mitao-shaonian"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-bold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-500/30"
            >
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </div>
                开始阅读
              </div>
            </Link>
            <Link
              to="/category/shaonian"
              className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm md:text-base hover:bg-background-50/25 border border-background-50/20 transition-all duration-300 whitespace-nowrap"
            >
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-grid-line"></i>
                </div>
                浏览分类
              </div>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            {[
              { value: '5000+', label: '漫画作品' },
              { value: '1200万+', label: '月活用户' },
              { value: '9.6', label: '平均评分' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">{stat.value}</div>
                <div className="text-xs md:text-sm text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}